export default __webpack_public_path__ + "static/media/fles.39659688.png";